export default "__VITE_ASSET__CKZPE2cH__"